import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { SingleOrderType } from './data';
import { getOrderListPage, streetVerifyOrder, districtVerifyOrder, settleBegin, settleComplete } from './service';

export type OrderListState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: SingleOrderType[];
};

type OrderListModelType = {
  namespace: string;
  state: OrderListState;
  reducers: {
    OrderListReducer: Reducer<OrderListState>;
  };
  effects: {
    fetchOrderListPageEffect: Effect;
    refreshDataEffect: Effect;
    streetVerifyEffect: Effect;
    districtVerifyEffect: Effect;
    settleBeginEffect: Effect;
    settleCompleteEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const OrderListModel: OrderListModelType = {
  namespace: 'orderList',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    OrderListReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as OrderListState;
    },
  },

  effects: {
    *fetchOrderListPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getOrderListPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'OrderListReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.orderList.current);
      const pageSize = yield select((state: any) => state.orderList.pageSize);
      yield put({
        type: 'fetchOrderListPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },

    // 街道审批
    *streetVerifyEffect(
      { payload }: any,
      { call }: any,
    ): Generator<any, any, any> {
      const res = yield call(streetVerifyOrder, payload);
      return res;
    },

    // 区县审批
    *districtVerifyEffect(
      { payload }: any,
      { call }: any,
    ): Generator<any, any, any> {
      const res = yield call(districtVerifyOrder, payload);
      return res;
    },

    // 结算开始
    *settleBeginEffect(
      { payload }: any,
      { call }: any,
    ): Generator<any, any, any> {
      const res = yield call(settleBegin, payload);
      return res;
    },

    // 结算完成
    *settleCompleteEffect(
      { payload }: any,
      { call }: any,
    ): Generator<any, any, any> {
      const res = yield call(settleComplete, payload);
      return res;
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default OrderListModel;
